import React, { useState } from "react";
import { supabase } from "../supabaseClient";
import { useNavigate } from "react-router-dom";

function ResetPassword() {
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleUpdatePassword = async () => {
    const { error } = await supabase.auth.updateUser({
      password: password,
    });

    if (error) {
      alert(error.message);
    } else {
      alert("Password updated successfully");
      navigate("/");
    }
  };

  return (
    <div style={{ padding: "50px", textAlign: "center" }}>
      <h2>Set New Password</h2>

      <input
        type="password"
        placeholder="New Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={{ padding: "10px", marginBottom: "10px" }}
      />

      <br />

      <button onClick={handleUpdatePassword}>
        Update Password
      </button>
    </div>
  );
}

export default ResetPassword;